import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { createValidateSearch } from '@authy/lib-web/routes'

import { rootRoute } from '@/tenant/applications/root'

import { SearchSchema, listApplications } from './routeUtils'

const validateSearch = createValidateSearch(SearchSchema)

export const listRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/list',
    component: lazyRouteComponent(() => import('./List'), 'List'),
    validateSearch,
    loaderDeps: ({ search }) => search,
    loader: ({ deps, abortController }) => listApplications(deps, 0, abortController),
})
